import { AnyObject } from "../types/common";

export const searchParamsToPath = (searchParams: AnyObject<string>): string =>
  Object.keys(searchParams)
    .map((key) => `${key}=${searchParams[key]}`)
    .join("&");
